import InfoItem from "@/components/application/InfoItem";
import { RejectRegistration } from "@/services/application.service";
import { Button, Form, Grid, Input, message, Modal, Typography } from "antd";
import { useState } from "react";

interface RejectApplicationModalProps {
  open: boolean;
  registrationId: string;
  name: string;
  onClose: () => void;
  onBack: () => void;
  onConfirm: () => void;
  onSuccess?: () => void;
}

const { Title } = Typography;
const { useBreakpoint } = Grid;

const modalStyles = {
  container: { padding: 0 },
  header: { padding: 0, marginBottom: 0 },
  body: { padding: 24 },
  footer: { padding: "0 16px 16px" },
} as const;

export function RejectApplicationModal({
  open,
  registrationId,
  name,
  onClose,
  onBack,
  onConfirm,
  onSuccess,
}: RejectApplicationModalProps) {
  const screens = useBreakpoint();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!registrationId) {
      message.error("Registration ID tidak dijumpai.");
      return;
    }

    try {
      setLoading(true);

      const values = await form.validateFields();

      await RejectRegistration({
        registrationId,
        reason: values.reason ?? "",
      });

      onConfirm();
      form.resetFields();
      onSuccess?.();
    } catch (error) {
      console.error("Reject registration error:", error);

      message.error(
        error instanceof Error ? error.message : "Gagal menolak permohonan.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <div className="flex items-center justify-between p-4 sm:p-6 bg-[#E5F2FF] rounded-tl-2xl rounded-tr-2xl">
          <Title
            level={2}
            style={{ margin: 0, fontSize: screens.xs ? "18px" : "22px" }}
          >
            Tolak
          </Title>
        </div>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      styles={modalStyles}
      width={1200}
      centered
    >
      <Title
        level={2}
        style={{
          textAlign: "center",
          fontSize: screens.xs ? 18 : 24,
          fontWeight: 700,
          marginBottom: 40,
        }}
      >
        Adakah anda pasti ingin <span className="text-[#FF4D4F]">menolak</span>{" "}
        permohonan ini?
      </Title>

      <div className="mb-8">
        <InfoItem label="Nama" value={name} />
      </div>

      <Form form={form} layout="vertical" requiredMark={false}>
        <Form.Item
          label={renderLabel("Sebab", false)}
          name="reason"
          layout="vertical"
        >
          <Input.TextArea placeholder="Masukkan sebab" size="large" rows={4} />
        </Form.Item>
      </Form>

      <div className="grid grid-cols-2 gap-6 sm:gap-10 mt-8">
        <Button
          color="default"
          variant="solid"
          size="large"
          onClick={onBack}
          className="w-full"
        >
          Kembali
        </Button>

        <Button
          type="primary"
          size="large"
          style={{ backgroundColor: "#C00" }}
          className="w-full"
          onClick={handleConfirm}
          loading={loading}
        >
          Tolak
        </Button>
      </div>
    </Modal>
  );
}

function renderLabel(text: string, required = false) {
  return (
    <span className="text-sm text-[#666] leading-none font-semibold">
      {text}
      {required && <span className="text-red-500">*</span>}
    </span>
  );
}
